
import { Dashboard } from '../components/Dashboard'
import { useTranslation } from "react-i18next";
import { Table, SORT } from '../components/Table'
import { useEffect, useState, useRef } from 'react';
import { axiosInstance } from '../common/utils';
import {useSelector, useDispatch} from 'react-redux'
import Modal from 'react-bootstrap/Modal';
import { ModalConfirmation } from '../components/ModalConfirmation';
import { ModalWarning } from '../components/ModalWarning';
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom"
import routes from '../common/routes'

const CompanyModal = (props) => {
  const { t } = useTranslation();
  const [ company, setCompany ] = useState({
    name: '', github_deploy_key: ''
  });

  const onSave = async () => {
    try{
      // Create
      if( props.targetUuid == null){
        await axiosInstance.post(`/api/v1/companies/`, {...company});
      }

      // Update
      if( props.targetUuid ){
        await axiosInstance.put(`/api/v1/companies/${props.targetUuid}/`, {...company});
      }

      // Call parent
      props.onSave();
      toast.success(t('request_succeded'))
    }catch(e){   
      toast.error(t('request_failed'))   
    }
  }

  useEffect( () => {
    ( async () => {
      try{
        if( props.targetUuid == null){
          setCompany({ name: '', github_deploy_key: '' })
          return
        }


        if( props.targetUuid){
          const response = await axiosInstance.get(`/api/v1/companies/${props.targetUuid}/`);
          setCompany({github_deploy_key: '', ...response.data})
          return
        }
      }catch(e){   
        toast.error(t('request_failed'))   
      }
    })();

  }, [props.show, props.targetUuid, t])

  const operation = props.targetUuid?t('edit'):t('add')
  return (<Modal show={props.show} onHide={() => props.onCancel()} centered>
            <Modal.Header closeButton>
              <Modal.Title>{operation} {t('user')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="form-group">
                <label>{t('name')}</label>
                <input type="text" className="form-control mt-2" 
                  value={company.name} onChange={(e) => setCompany({...company, name: e.target.value})} />
              </div>
              <div className="form-group mt-2">
                <label>{t('github_deploy_key')}</label>
                <textarea type="text" className="form-control mt-2" style={{ resize: 'none'}} rows={10}
                  value={company.github_deploy_key} onChange={(e) => setCompany({...company, github_deploy_key: e.target.value})} />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button type="button" className="btn btn-secondary"
                onClick={() => props.onCancel()}>
                {t('cancel')}
              </button>
              <button type="button" className="standalone-button btn btn-primary"
                onClick={() => onSave()}>
                {t('save')}
              </button>
            </Modal.Footer>
          </Modal>)
}

export const Company = () => {
  const { t } = useTranslation();
  const [data, setData] = useState({ count: 0, results: []})
  const [loading, setLoading] = useState(false)
  const [showDetail, setShowDetail] = useState(false)
  const targetUuid = useRef(null)
  const pageSizeRef = useRef(10);
  const offsetRef = useRef(0);
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [showWarning, seShowWarning] = useState(false)
  const user = useSelector(state => state.main.user)
  const parameters = useRef({})
  const navigate = useNavigate();

  const headers = [
    { key: 'name', title: t('name'), sort: SORT.DEFAULT },
    { key: 'calc_company_sites', title: t('calc_company_sites'), sort: SORT.DEFAULT, className: 'text-center',
    rendering: (uuid, item) => {
        return <div className='text-center'>
                  <span className="badge bg-primary"  onClick={() => navigate( routes.company_site.url(uuid) )}>
                  {item} sites
                  </span>
                </div>
      } 
    },
  ]

  const refresh = async (limit, offset, parameters = {}) => {
    try{
      setLoading(true)
      const urlParams = new URLSearchParams(parameters).toString();
      const response = await axiosInstance.get(`/api/v1/companies/?limit=${limit}&offset=${offset}${urlParams.length>0?`&${urlParams}`:''}`);
      setData(response.data)
      setLoading(false)
    }catch(e){   
      toast.error(t('request_failed'))   
    }
  }

  useEffect( () => {
    if( user )
      refresh(pageSizeRef.current, offsetRef.current)
  }, [user]);

  // -------------------
  // Handlers
  // -------------------

  const onPageChange = async (pageSize, page) => {
    // Store parameters
    pageSizeRef.current = pageSize;
    offsetRef.current = pageSize*page;
    // Refresh
    refresh(pageSizeRef.current, offsetRef.current, parameters.current)
  }

  const onSortClick = async (key, direction, pageSize, page) => {
    const prefix = direction === SORT.DOWN?"-":""
    parameters.current = { ...parameters.current, ordering : `${prefix}${key}` }
    pageSizeRef.current = pageSize;
    offsetRef.current = page;
    refresh(pageSizeRef.current, offsetRef.current, parameters.current)
  }

  const onSearch = (pattern, pageSize, page) => {
    parameters.current = { ...parameters.current, search : pattern }
    pageSizeRef.current = pageSize;
    offsetRef.current = page;
    refresh(pageSizeRef.current, offsetRef.current, parameters.current)
  }

  const onClickEdit = (uuid) => {
    targetUuid.current = uuid;
    setShowDetail(true)
  }

  const onClickDelete = (uuid) => {
    const obj = data.results.find( item => item.uuid === uuid );
    if(obj.calc_company_sites > 0 ){
      seShowWarning(true)
      return
    }

    // Proceed to delete
    targetUuid.current = uuid;
    setShowConfirmation(true)
  }

  const onDeleteProceed = async () => {
    try{
      setShowConfirmation(false)

      await axiosInstance.delete(`/api/v1/companies/${targetUuid.current}/`);

      // Refresh
      refresh(pageSizeRef.current, offsetRef.current, parameters.current)

      toast.success(t('request_succeded'))
    }catch(e){   
      toast.error(t('request_failed'))   
    }
  }

  const onClickAdd = () => {
    targetUuid.current = null;
    setShowDetail(true)
  }
  
  const onSaveCompleted = () => {
    // Refresh
    refresh(pageSizeRef.current, offsetRef.current, parameters.current)
    setShowDetail(false)
  }

  return <div className='h-100'>
          <Table data={data} headers={headers} 
            onSortClick={ (key, direction, pageSize, page) => onSortClick(key, direction, pageSize, page)} 
            onClickRow={(id) => onClickEdit(id)} 
            onClickDelete={(id) => onClickDelete(id)} 
            onClickAdd={() => onClickAdd()} 
            onPageChange={(pageSize, page) => onPageChange(pageSize, page)} 
            loading={loading} 
            onSearch={(pattern, pageSize, page) => onSearch(pattern, pageSize, page)} />

          <ModalConfirmation title={`${t('delete')} ${t('company')}`} 
            onCancel={() => setShowConfirmation(false)} 
            onProceed={() => onDeleteProceed()}
            show={showConfirmation} />

          <ModalWarning title={t('warning')}
            message={t('dependent_company_sites')}
            show={showWarning} 
            onProceed={() => seShowWarning(false)}
            />

          <CompanyModal show={showDetail} 
            onCancel={() => setShowDetail(false)}
            onSave={() => onSaveCompleted()}
            targetUuid={targetUuid.current}
            />

        </div>    
  
}
